import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"
import { formControlLabelClasses, radioClasses } from "@mui/material"

export const useStyles = makeStyles()(({ spacing, typography }) => ({
  radioGroup: {
    [`& .${formControlLabelClasses.root}`]: {
      marginBottom: spacing(0)
    }
  },
  radio: {
    color: blueGrey[300],

    [`&.${radioClasses.checked}`]: {
      color: lightBlue[500]
    }
  },
  customTimeIcon: {
    color: blueGrey[500]
  },
  adorment: {
    color: blueGrey[500],
    fontSize: typography.body1.fontSize
  }
}))
